// packages/content/src/tuning/fruit.ts — sell prices live in tuning.shop (Contract change 1)
import type { TuningBank } from '../schema/tuning';
export default { shakeDrop: 3, cooldownDays: 3, saplingStages: 3, growDays: 4 } as const satisfies TuningBank;
